export default "__VITE_ASSET__9218fdbe__"